import { useEffect, useState } from "react";
import { CalendarDays, Clock, Gamepad2, Timer } from "lucide-react";

function pad(n) { return String(n).padStart(2, "0"); }

export function NextMatchCountdown({ nextMd, onPlay }) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!nextMd?.date) return null;

  const deadline = new Date(nextMd.date);
  deadline.setHours(15, 0, 0, 0);
  const diff = deadline.getTime() - now;
  const passed = diff <= 0;
  const d = Math.max(0, diff);
  const days = Math.floor(d / 86400000);
  const hrs = Math.floor((d % 86400000) / 3600000);
  const mins = Math.floor((d % 3600000) / 60000);
  const secs = Math.floor((d % 60000) / 1000);

  const dateFmt = (() => {
    try {
      return new Date(nextMd.date).toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long" });
    } catch { return nextMd.date; }
  })();

  const Box = ({ v, l }) => (
    <div className="flex flex-col items-center">
      <span className="font-display font-black text-2xl sm:text-3xl text-white tabular-nums">{pad(v)}</span>
      <span className="text-[9px] uppercase tracking-widest text-slate-500">{l}</span>
    </div>
  );

  return (
    <div className="ap-card p-5 flex flex-col lg:flex-row lg:items-center gap-5" data-testid="next-countdown">
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 text-fuchsia-400">
          <Timer className="w-4 h-4" />
          <span className="text-xs font-semibold uppercase tracking-[0.2em]">
            {passed ? "Pronostici in chiusura" : "Chiusura pronostici tra"}
          </span>
        </div>
        <div className="mt-1 flex items-center gap-2 text-slate-300 text-sm">
          <CalendarDays className="w-4 h-4 text-cyan-400 shrink-0" />
          <span className="capitalize truncate">Giornata {nextMd.number} · {dateFmt}</span>
          <span className="hidden sm:inline text-slate-600">·</span>
          <span className="hidden sm:flex items-center gap-1 text-slate-500"><Clock className="w-3.5 h-3.5" />ore {nextMd.time || nextMd.matches?.[0]?.time || "15:00"}</span>
        </div>
      </div>

      {!passed ? (
        <div className="flex items-center gap-3 sm:gap-5">
          <Box v={days} l="giorni" />
          <span className="font-display font-black text-xl text-slate-700">:</span>
          <Box v={hrs} l="ore" />
          <span className="font-display font-black text-xl text-slate-700">:</span>
          <Box v={mins} l="min" />
          <span className="font-display font-black text-xl text-slate-700">:</span>
          <Box v={secs} l="sec" />
        </div>
      ) : (
        <span className="text-sm text-amber-400 font-semibold">Affrettati, la giornata sta per iniziare!</span>
      )}

      <button
        data-testid="countdown-play-btn"
        onClick={onPlay}
        className="shrink-0 inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full bg-fuchsia-500 hover:bg-fuchsia-400 text-white font-bold uppercase text-xs tracking-wide transition-colors"
      >
        <Gamepad2 className="w-4 h-4" />
        Chiudi il tuo pronostico
      </button>
    </div>
  );
}
